import React from 'react'
import styled from 'styled-components'

import { Breakpoints, Colors } from '../../constants'

const StyledCloseButton = styled.button`
  border: 3px solid ${Colors.WATERLOO};

  background-color: transparent;
  color: ${Colors.WHITE};
  border-radius: 10px;
  cursor: pointer;

  &: hover {
    background: unset;
    border: 3px solid ${Colors.WHITE};
    background-color: ${Colors.WHITE};
    color: ${Colors.BLACK};
  }

  @media only screen and (max-width: ${Breakpoints.MOBILE_S}px) {
    font-size: 14px;
    padding: 10px 15px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE_S}px) {
    font-size: 16px;
    padding: 10px 20px;
  }
`

export const ModalCloseButton = ({
  onClick,
  children,
  text,
}: {
  onClick?: any
  text?: string
  children: React.ReactChild
}) => {
  return (
    <StyledCloseButton onClick={onClick}>
      {children ? children : text}
    </StyledCloseButton>
  )
}
